import React, { useState, useEffect } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import CustomInput from "../../components/CustomInput/CustomInput.js";
import Button from "../../components/CustomButtons/Button.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import CardFooter from "../../components/Card/CardFooter.js";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import customInputStyle from "../../assets/jss/material-dashboard-react/components/customInputStyle.js";
import Web3 from "web3";
import "react-phone-input-2/lib/style.css";
import dexbot from "../../ABI/dexbot.json";
import config from "../../actions/config";
import {
    getcommissiondata,
    postPlandata,
    updatecommission,
    commissionHistory
} from "../../actions/admin.js";
import { toastAlert } from "../../lib/toastAlert.js";
import isEmpty from "../../lib/isEmpty.js";
import { AmpStories } from "@material-ui/icons";

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0",
    },
    cardTitleWhite: {
        // getadminUsers,
        textDecoration: "none",
    },
};

// toaster config
let toasterOption = {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
};

const initialFormValue = {
    name: "",
};

const useStyles = makeStyles(styles);

const customStyle = makeStyles(customInputStyle);

export default function UserProfile() {
    const customStyles = customStyle();

    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();

    const [formData, setFormData] = useState(initialFormValue);
    const [validateError, setValidateError] = useState({});
    const [adminnameset, setAdminName] = useState("");
    const [adminid, setadminid] = useState("");
    const [Account, setAccount] = useState()
    const [FormSubmitLoading, Set_FormSubmitLoading] = useState("")
    const [Queenplan, setQueenplan] = useState("")
    const [QueenAmount, setQueenAmount] = useState("")// // console.log(adminid);
    // // console.log(adminnameset, "adminnamesetadminnamesetadminnameset");
    const [FormSubmitLoading1, Set_FormSubmitLoading1] = useState("")


    const onChange = (e) => {
        e.preventDefault();
        if (e.target.name === "Admin") {
            const { name, value } = e.target;
            setAdminName(value);


        } else if (e.target.name === "Merchant") {
            const { name, value } = e.target;
            setQueenAmount(value);


        }
    };



    useEffect(() => {
        acc();
    }, []);

    const acc = async () => {
        const web3 = new Web3(window.ethereum);
        let accounts = await web3.eth.requestAccounts();
        setAccount(accounts);
    };



    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (Account != config.admin_address) {
            toast.error("connect your valid account", toasterOption);
            return false;
        }
        if (adminnameset == "") {
            toast.warning("Admin Commission Must Not be Empty", toasterOption);
            return false;
        }

        try {

            let reqData = {
                percentage: adminnameset,
                id: adminid,
            };
            // console.log(reqData, "adminid");
            const { status, message, error, result } = await updatecommission(reqData);
            console.log(status, "ll");
            const history = await commissionHistory({ Admin: adminnameset, merchant: QueenAmount })
            console.log(history);
            if (status) {
                toast.success("Update Successfully", toasterOption);
                // history.push("/dashboard");
                Set_FormSubmitLoading("done")
                //window.location=('/categorylist')
            } else if (error) {
                setValidateError(error);
                Set_FormSubmitLoading("done")
            }
        } catch (err) {
            // // console.log(err.length);
            toast.error("Transaction rejected by user", toasterOption);
            Set_FormSubmitLoading("done")
        }
    };



    const handleSubmitQueen = async (e) => {
        e.preventDefault();
        if (Account != config.admin_address) {
            toast.error("connect your valid account", toasterOption);
            return false;
        }
        if (QueenAmount == "") {
            toast.warning("Merchant Commission Must Not be Empty", toasterOption);
            return false;
        }
        try {

            let reqData = {
                percentage: QueenAmount,
                id: Queenplan,
            };
            // console.log(reqData, "adminid");
            const { status, message, error, result } = await updatecommission(reqData);
            const history = await commissionHistory({ Admin: adminnameset, merchant: QueenAmount })


            if (status) {
                toast.success("Update Successfully", toasterOption);
                // history.push("/dashboard");
                Set_FormSubmitLoading1("done")
                //window.location=('/categorylist')
            } else if (error) {
                setValidateError(error);
                Set_FormSubmitLoading1("done")
            }
        } catch (err) {
            // // console.log(err.length);
            toast.error("Transaction rejected by user", toasterOption);
            Set_FormSubmitLoading1("done")
        }
    };





    const getadmindata = async () => {
        var result = await getcommissiondata();
        console.log(result, "kk");

        if (result != null) {
            setadminid(result.result[0]?._id);
            setAdminName(result.result[0]?.percentage);
            setQueenplan(result.result[1]?._id);
            setQueenAmount(result.result[1]?.percentage)
        }
    };
    useEffect(() => {
        //logout(history)
        getadmindata();
    }, []);

    return (
        <div>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <form
                            className={classes.form}
                            onSubmit={handleFormSubmit}
                            noValidate
                        >
                            <CardHeader color="primary">
                                <h4 className={classes.cardTitleWhite}>
                                    Update Admin Commission
                                </h4>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={3}>
                                        <CustomInput
                                            labelText="Admin Commission %"
                                            onChange={onChange}
                                            name="Admin"
                                            value={adminnameset}
                                            formControlProps={{
                                                fullWidth: true,
                                            }}
                                        />


                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                            <CardFooter>
                                <Button color="primary" type="submit" disabled={FormSubmitLoading == "processing"}>
                                    {FormSubmitLoading == "processing" && (
                                        <i
                                            class="fa fa-spinner fa-spin"
                                            aria-hidden="true"
                                            id="circle"
                                        ></i>
                                    )}
                                    Update
                                </Button>
                            </CardFooter>
                        </form>
                    </Card>
                </GridItem>
            </GridContainer>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <form
                            className={classes.form}
                            onSubmit={handleSubmitQueen}
                            noValidate
                        >
                            <CardHeader color="primary">
                                <h4 className={classes.cardTitleWhite}>
                                    Update Merchant Commission
                                </h4>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={3}>
                                        <CustomInput
                                            labelText="Merchant Commission %"
                                            onChange={onChange}
                                            name="Merchant"
                                            value={QueenAmount}
                                            formControlProps={{
                                                fullWidth: true,
                                            }}
                                        />


                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                            <CardFooter>
                                <Button color="primary" type="submit" disabled={FormSubmitLoading1 == "processing"}>
                                    {FormSubmitLoading1 == "processing" && (
                                        <i
                                            class="fa fa-spinner fa-spin"
                                            aria-hidden="true"
                                            id="circle"
                                        ></i>
                                    )}
                                    Update
                                </Button>
                            </CardFooter>
                        </form>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
}
